module.exports = __webpack_public_path__ + "img/tit-live.72c5937f.jpg";